import { call, takeLatest } from "redux-saga/effects";
import { ListManagerCalendarConstants } from "../../../Constants/ListManagerCalendarConstants";
import listManagerCalendarApi from "../../../ServiceApi/Apis/ListManagerCalendarApi";

const { ActionTypes } = ListManagerCalendarConstants;

function* saveEventFavourite({ osid, is_starred, event_name, event_type, event_date }) {
    try {
        const formatYYYYMMDD = (input) => {
            const date = input instanceof Date ? input : new Date(input);
            if (isNaN(date)) return input; // fallback if invalid date
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            return `${yyyy}${mm}${dd}`;
        };
        const formattedEventDate = formatYYYYMMDD(event_date);
        const response = yield call(listManagerCalendarApi.saveUserEventFavourite, {
            osid,
            is_starred,
            event_name,
            event_type,
            event_date: formattedEventDate
        });
        if (response.status !== 200) {
            console.error("Error saving event favourite:", response);
        }
    } catch (error) {
        console.error("Error saving event favourite:", error);
    }
}

export function* watchSaveEventFavourite() {
    yield takeLatest(ActionTypes.SAVE_USER_EVENT_FAVOURITE, saveEventFavourite);
}
